
import { Options, Vue } from "vue-class-component";

export default class UiTableHeaderComponent extends Vue {}
